module.exports = __webpack_public_path__ + "static/media/snapshot3.8f66ba7b.png";